module.exports = __webpack_public_path__ + "static/img/title.4251b73.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/activity4/title.png
// module id = 52bR
// module chunks = 7